import React from 'react';
import { Flag } from 'lucide-react';
export function TrustBanner() {
  return <div className="bg-museum-black text-white py-2.5 px-4 text-center text-xs font-medium tracking-wide" data-id="element-278">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2" data-id="element-279">
        <Flag className="w-3.5 h-3.5 text-museum-red" data-id="element-280" />
        <span data-id="element-281">
          We proudly design, print, and assemble everything in the USA. No
          Tariffs. No Delays.
        </span>
        <a href="#" className="text-museum-blue hover:underline ml-1" data-id="element-282">
          Learn more.
        </a>
      </div>
    </div>;
}